import styled from 'styled-components';

const ContenedorError = styled.div`
.logo img {
  margin-left: 9px;
}
.logo {
    background-color: #f42534;
  }

  strong {
    font-weight: bold;
  }

  .cabecera-webpay-coopeuch img {
    padding: 22px;
  }

  .contenedor-imagenes-wepbay img {
    width: 152px;
    padding: 4px 0 10px 10px;
  }
  .body-webpay-coopeuch {
    background-color: #fbfbfb;
  }
  .contenedor-imagenes-wepbay {
    display: flex;
    margin: 0 auto;
    padding-top: 16px;
    justify-content: center;
    align-items: center;
    height: 90px;
  }
  @media (max-width: 426px){
    .cabecera-webpay-coopeuch img {
      padding: 14px;
      width: 145px;
    }
  }
  @media (max-width: 376px){
    .cabecera-webpay-coopeuch img {
      padding: 14px;
      width: 145px;
  }
}
  @media (max-width: 321px){
    .cabecera-webpay-coopeuch img {
      width: 142px;
      padding: 17px;
    }
  }
 
`;

export default ContenedorError;